import React, { useContext } from "react";
import merge from "deepmerge";

import { useAppContext } from "../../../../lib/appContext";
import { ProductContext } from "../../context/product";
import { Attributes } from "./Attributes";
import { Title } from "./CategoryTitle";
import { useDetailContentProps } from "./hooks";
import { MainContent } from "./MainContent";
import { Placeholder } from "./Placeholder";
import { StickyHeader } from "./StickyHeader";
import { Reviews } from "../Reviews";
import { IDetailContentProps } from "./types";
import { useExternalURLRedirection } from "../../../../core/hooks";
import { useRouter } from "../../../../lib/routerContext";

const EXCLUDE_COUNTRY_CODES = ["co", "br"];
const EXCLUDE_PRODUCT_URL = "product";

const DetailContent: React.FC<IDetailContentProps> = ({
  relativeSticky,
  headerProps: externalHeaderProps,
  onClickCta
}) => {
  const router = useRouter();
  const path = (router && router.asPath) || "";
  const { isMobile, countryCode } = useAppContext();
  const { loading, headerProps, attributeProps } = useDetailContentProps(onClickCta);
  const { id: offerId, formId } = useContext(ProductContext);

  useExternalURLRedirection(
    "newOfferDetail",
    { offerId, formId },
    {},
    !loading && !EXCLUDE_COUNTRY_CODES.includes(countryCode) && !path.includes(EXCLUDE_PRODUCT_URL)
  );

  if (loading) {
    return <Placeholder />;
  }
  return (
    <>
      <StickyHeader
        isMobile={isMobile}
        relativeSticky={relativeSticky}
        headerProps={merge(headerProps || {}, externalHeaderProps || {})}
      />
      <MainContent>
        <Title />
        <Attributes {...attributeProps!} />
        <Reviews />
      </MainContent>
    </>
  );
};

DetailContent.defaultProps = {
  relativeSticky: false
};

export { DetailContent };
